exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n@media only screen and (max-width: 1024px) {\r\n    .hashtag {\r\n        font-size: 1.2rem;\r\n    }\r\n    .trendBrand{\r\n        font-size: 1.1rem;\r\n    }\r\n    .trend-topic-title{\r\n        font-size: 1.3rem;\r\n    }\r\n    .mobile-trending{\r\n        margin-bottom: 100px;\r\n    }\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/trending/trending.component.css
// module id = ../../../../../src/app/trending/trending.component.css
// module chunks = main